export type ViewPaymentOutcome = "success" | "failure" | "wire-pending";

const RECEIVED_PAYMENT_STATUSES = new Set([
  "succeeded",
  "refunded",
  "partial refund",
]);

const RETRYABLE_PAYMENT_STATUSES = new Set(["failed", "incomplete"]);
const WIRE_PAYMENT_METHODS = new Set(["WT", "WTO"]);

const normalizeStatus = (status: unknown): string =>
  typeof status === "string" ? status.trim().toLowerCase() : "";

const normalizePaymentMethod = (paymentMethod: unknown): string =>
  typeof paymentMethod === "string" ? paymentMethod.trim().toUpperCase() : "";

export const getViewPaymentOutcome = (
  paymentStatus: unknown,
  paymentMethod: unknown
): ViewPaymentOutcome => {
  const status = normalizeStatus(paymentStatus);
  const method = normalizePaymentMethod(paymentMethod);

  if (WIRE_PAYMENT_METHODS.has(method) && status === "pending") {
    return "wire-pending";
  }

  if (RECEIVED_PAYMENT_STATUSES.has(status)) {
    return "success";
  }

  // Missing and future statuses deliberately fail closed: a successful API
  // lookup is not evidence that the payment itself succeeded.
  return "failure";
};

export const isRetryablePaymentStatus = (paymentStatus: unknown): boolean =>
  RETRYABLE_PAYMENT_STATUSES.has(normalizeStatus(paymentStatus));
